import { get } from '@ember/object';
import _sortBy from 'lodash.sortby';

export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

export function generateSortBy(sortDirection: SortDirection, accessor: string | ((obj: Record<string, any>) => any)) {
  let sortModifier = sortDirection === SortDirection.Ascending ? 1 : -1;

  return function (a: Record<string, any>, b: Record<string, any>) {
    let valueA = typeof accessor === 'string' ? get(a, accessor) : accessor(a);
    let valueB = typeof accessor === 'string' ? get(b, accessor) : accessor(b);

    if (typeof valueA === 'string' || typeof valueB === 'string') {
      return valueA.localeCompare(valueB, undefined, { sensitivity: 'accent' }) * sortModifier;
    }

    // Sort non-null values higher
    if (valueA != null && valueB == null) {
      return sortModifier;
    }

    if (valueA == null && valueB != null) {
      return sortModifier * -1;
    }

    if (valueA > valueB) {
      return sortModifier;
    }

    if (valueA < valueB) {
      return sortModifier * -1;
    }

    return 0;
  };
}

// A wrapper around "lodash.sortby" with which "Z" doesn't go before "a":
// (This mirrors deprecated Ember.MutableArray.sortBy(...) behaviour which we
// used previously.)
export function sortByCaseInsensitive<T>(arr: T[], sortProps: (keyof T)[]) {
  let sortFuncs = sortProps.map((p) => (o: T) => (typeof o[p] === 'string' ? String(o[p]).toLowerCase() : o[p]));
  return _sortBy(arr, ...sortFuncs);
}
